export function initZohoDesk() {
    // Inject the Zoho SDK script
    const script = document.createElement('script');
    script.src = "https://js.zohostatic.com/support/developer_sdk/v1/js/ZohoDeskClientSDK.min.js";
    script.async = true;

    script.onload = () => {
        if ((window as any).ZOHODESK && (window as any).ZOHODESK.extension) {
            (window as any).ZOHODESK.extension.onload().then(async function (App: any) {
                console.log("App", App);
                (window as any).deskSDKApp = App;
                try {
                    const response = await (window as any).ZOHODESK.get("ticket");
                    console.log(response["ticket"]);
                } catch (err) {
                    // handle error here...
                    console.error("ZOHODESK.get('ticket') error:", err);
                }
            });
        }
    };

    document.head.appendChild(script);
}
